import { render, staticRenderFns } from "./sIdentify.vue?vue&type=template&id=2bb8bd62"
import script from "./sIdentify.vue?vue&type=script&lang=js"
export * from "./sIdentify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports